import '../scss/frontend.scss';
import Sliders from './components/swiper-init';
import Popup from './parts/popup-window';
import { dropdownNavigatorInit, mobileMenuInit } from './components/header-init';
import { anchorLinkScroll, highlightActiveTab, toggleTab } from './parts/helpers';
import { timelineCheck } from './acf-blocks/block-horisontal-timeline';
import videoInit from './components/video-init';
import initDefaultTabs from './components/tabs-init';
import { copyTriggersInit } from './components/copy-onboard-init';
import { anchorInit } from './components/anchor-init';
import search from './parts/search';
import { initActionsBookmarks, removeBookmarkInShop } from './components/bookmarks-init';
import { authFormSubmitHandler, popupAuthAccordion, registrationCustomer } from './components/popup-auth';
import anchorTabs from './components/anchors-tabs';
import initializeBackToTopButton from './components/back-on-top';
import initBlockPortalTags from './components/tags';
function ready() {
    const popupInstance = new Popup();
    const header = document.querySelector('.site-header');
    popupInstance.init();
    Sliders.initSwiperPersonality();
    Sliders.initSwiperLiterature();
    popupAuthAccordion();
    authFormSubmitHandler();
    registrationCustomer();
    anchorInit();
    anchorTabs();
    initBlockPortalTags();
    mobileMenuInit();
    dropdownNavigatorInit();
    highlightActiveTab();
    anchorLinkScroll('.js-anchor-link');
    timelineCheck();
    videoInit();
    initDefaultTabs();
    copyTriggersInit();
    search();
    initActionsBookmarks(popupInstance);
    initializeBackToTopButton();
    removeBookmarkInShop();
    window.document.addEventListener('scroll', () => {
        const operationType = header && Math.floor(window.scrollY) > 100 ? 'add' : 'remove';
        header.classList[operationType]('scroll-header');
    });
    {
        const operationType = header && Math.floor(window.scrollY) > 100 ? 'add' : 'remove';
        header.classList[operationType]('scroll-header');
    }
    window.document.addEventListener('click', (e) => {
        const TARGET = e.target;
        if (TARGET.classList.contains('js-tab-link')) {
            e.preventDefault();
            toggleTab(TARGET);
        }
    });
}
window.document.addEventListener('DOMContentLoaded', ready);
